import { useQueryClient } from '@tanstack/react-query';
import sosLogServices from '../services/sos-log.service';

export const usePrefetchSosLogs = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      const nextFilters = { ...filters, page: nextPage };
      queryClient.prefetchQuery({
        queryKey: ['sos-logs', nextFilters.page, nextFilters.limit, nextFilters.status, nextFilters.userType, nextFilters.alertType, nextFilters.userId, nextFilters.startDate, nextFilters.endDate, nextFilters.sortBy, nextFilters.sortOrder],
        queryFn: () => sosLogServices.getSosLogs(nextFilters),
        staleTime: 30 * 1000,
      });
    }
  };

  const prefetchSosLog = (sosLogId) => {
    queryClient.prefetchQuery({
      queryKey: ['sos-log', sosLogId],
      queryFn: () => sosLogServices.getSosLogById(sosLogId),
      staleTime: 30 * 1000,
    });
  };

  return { prefetchNextPage, prefetchSosLog };
};
